<template>
    <div class="search">
        <div class="inputs">
            <el-form class="queryConditions">
                <el-row v-for="row in items">
                    <el-col :span="6" v-for="cfg in row" :style="'width:'+cfg.width">
                        <component :is="ctxMap[cfg.ctx]" v-bind="cfg" :activeIndex = activeIndex @input="onInput"/>
                    </el-col>
                </el-row>
            </el-form>
        </div>
        <div class="action" v-if="showAction">
            <qx-btn @click="onClick('create')">{{ createButtonText }}</qx-btn>
            <qx-btn @click="onClick('export')" >导出</qx-btn>
        </div>
    </div>
</template>

<script>
    import QxBtn from "@/components/common/qx-btn"
    import InputText from "@/components/common/InputText"
    import InputSelect from "@/components/common/InputSelect"
    import InputRadio from "@/components/common/InputRadio"

    const ctxMap = {
        inputText:InputText,
        inputSelect:InputSelect,
        inputRadio:InputRadio,
    };
    export default {
        name: "BaseSearch",
        components: {QxBtn,InputText,InputSelect,InputRadio},
        props: {
            configs: Array,
            actions: Array,
            activeIndex:String,
            showAction: Boolean
        },
        data: function () {
            return {
                ctxMap:ctxMap,
            }
        },
        mounted: function () {
            this.init();
        },
        computed: {
            items: function () {
                return this.configs || []
            },
            createButtonText: function () {
                // 如果 actions 配置中有 create 按钮的文本，使用它；否则默认"新建"
                if (this.actions && this.actions.length > 0) {
                    const createAction = this.actions.find(action => action.name === 'create');
                    if (createAction && createAction.label) {
                        return createAction.label;
                    }
                }
                return '新建';
            }
        },
        methods: {
            init: function() {

            },
            onInput: function (val) {
                this.$emit('input', val);
            },
            onClick: function (action) {
                this.$emit('action', action);
            }
        }
    }
</script>

<style scoped>
    .search {
        border: solid 1px #e9e9e9;
        padding: 15px;
    }
    .btn {
        font-size: 10px;
        margin-right: 4px;
    }
</style>
